import Header from "./components/Header";
import Hero from "./components/Hero";
import LiveFeed from "./components/LiveFeed";
import Types from "./components/Types";
import Timeline from "./components/Timeline";
import Insight from "./components/Insight";
import Guide from "./components/Guide";
import Faq from "./components/Faq";
import About from "./components/About";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <LiveFeed />
        <Types />
        <Timeline />
        <Insight />
        <Guide />
        <Faq />
        <About />
        <Subscribe />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}